import React from "react";
import { useSelector } from "react-redux";
import { Strip } from "./Strip";
import { searchPrint } from "../../util/sort";
import { useSearch } from "../../context/SearchContext";
import { FABRIC_BG } from "../../util/tableRip";
import { StripNone } from "./StripNone";

export const PrintList = () => {
  const { hpFile, loading } = useSelector((state) => state.hpFile);
  const { searchQuery } = useSearch();
  let displayFiles = [];
  displayFiles = searchQuery
    ? searchPrint(hpFile, searchQuery)
    : hpFile || [];
  

  return (
      <React.Fragment >
        <div className="flex flex-col w-[100%] mx-auto py-4">
          {/* <div className="flex flex-row  w-[100%] my-4 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
            <div className="h-[5px] w-[8%] content-center">DATA</div>
            <div className="h-[5px] w-[8%] content-center">FOLDER</div>
            <div className="h-[5px] w-[8%] content-center">DESIGNER</div>
            <div className="h-[5px] w-[23%] content-center">ORDER</div>
            <div className="h-[5px] w-[33%] content-center "></div>
            <div className="h-[5px] w-[20%] content-center ">FINISH</div>
          </div> */}
          {displayFiles.length === 0 && <StripNone />}
          {displayFiles &&
            displayFiles.map((i, key) =>(
              <React.Fragment key={key}>
                <div
                  className={`w-[11.45%] flex justify-left  rounded-t-xl mt-4 mb-1 h-[40px] py-2 ${
                    Object.keys(FABRIC_BG).find((key) =>
                      i.folderFabric.toUpperCase().includes(key)
                    )
                      ? FABRIC_BG[
                          Object.keys(FABRIC_BG).find((key) =>
                            i.folderFabric.toUpperCase().includes(key)
                          )
                        ]
                      : ""
                  }`}
                >
                  <p
                    className=" my-auto font-bold m-3 w-[33%] text-left "
                    style={{ textTransform: "uppercase" }}
                  >
                  {loading && i.folderFabric}
                  </p>
                </div>

                <Strip i={i} key={key} color={i.folderFabric} />
              </React.Fragment>
            ))}
        </div>
      </React.Fragment>
    
  );
};
